const engravingActionTypes = Object.freeze({
    update: 'ENGRAVING_UPDATE',
    clear: 'ENGRAVING_CLEAR'
});

export default engravingActionTypes;
